var Ribbon_default = {
  "ribbon": "N5mSX",
  "ribbonText": "rRgZn",
  "imageRibbon": "Q-lAl"
};
export {
  Ribbon_default as default
};
//# sourceMappingURL=Ribbon-scss.js.map
